<template>
  <table v-if="load === 'success'" class="plc-table">
    <tr class="plc-table__header">
      <th class="plc-table__headerCell hidden-sm-only">Height</th>
      <th class="plc-table__headerCell hidden-sm-only">Time ago</th>
      <th class="plc-table__headerCell hidden-sm-only">Transactions</th>
      <th class="plc-table__headerCell hidden-sm-only">Total sent</th>
      <th class="plc-table__headerCell hidden-sm-only">Block size</th>
      <th class="plc-table__headerCell"></th>
    </tr>
    <home-history-row
      v-for="block in blocks"
      :key="block.height"
      :row="block"
      @mouseover="block.new = false"
    />
  </table>

  <div v-else-if="load === 'error'" style="color: rgba(255, 255, 255, 0.38); margin-top: 32px;">
    Unexpected Error!
  </div>

  <gl-loader v-else />
</template>

<script>
import HomeHistoryRow from './components/HomeHistoryRow'
import { getBlockList } from '@/services/api'
import { updatePeriod } from '@/config'
import GlLoader from '@gl/GlLoader'

export default {
  name: 'HomeHistory',
  components: { HomeHistoryRow, GlLoader },
  data() {
    return {
      load: 'loading',
      timer: null,
      blocks: [],
    }
  },
  mounted() {
    this.loadBlockList()
    this.timer = setInterval(() => {
      this.loadBlockList()
    }, updatePeriod)
  },
  beforeUnmount() {
    clearInterval(this.timer)
  },
  methods: {
    async loadBlockList() {
      const { data } = await getBlockList()
      if (data.state === 'success') {
        const old = this.blocks.filter(i => !i.new).map(i => i.height)
        const first = !this.blocks.length
        this.blocks = data.data.map(i => ({ ...i, new: !old.includes(i.height) && !first }))
        this.load = 'success'
      } else if (!this.blocks.length) {
        this.load = 'error'
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/blocks/table';
</style>
